import { Environment } from './environment.interface';
import { APP_VERSION } from './version.generated';

export const environment: Environment = {
  production: false,
  // Remote Supabase DEV instance
  supabaseUrl: 'https://lknntmiydntzdkauwpec.supabase.co',
  supabaseAnonKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxrbm50bWl5ZG50emRrYXV3cGVjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk4NjE4ODAsImV4cCI6MjA3NTQzNzg4MH0.0wFixHjAB_8wRBaqqboso8Vf4wgbUaForne4iONhvRw',
  sentryDsn: 'https://d3f5c0353419f1d10ef61bb04f05864a@o4511265344847872.ingest.us.sentry.io/4511265565245440',
  // Replace with the real DEV Amplitude API key once the Amplitude project is created
  amplitudeApiKey: 'aa15fc5ffb7b7bb929da8163a73c13b2',
  version: APP_VERSION,
};
